import Rest from '@services/Rest'

/**
 * @typedef {ReleasePaymentService}
 */
export default class ReleasePaymentService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/release-payment'
}
